import { useEffect, useCallback, useState, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Grid, Button, CircularProgress, FormControlLabel, Checkbox, Typography } from '@mui/material';
import { SelectField, TextField, DateTimePicker, MultilineField, Dialog } from 'style-guide';

import { STATUS } from 'constants/global-constants';
import { REQUEST_ACTIONS, sendRequest } from 'utils/Communicator';

import { useDispatch, useSelector } from 'react-redux';
import { getOrders } from 'reducers/order-reducers/ordersSlicer';
import { snackbarToggle } from 'reducers/snackbarSlicer';
import CustomsUIItems from './CustomsUIItems';
import CustomsUIError from './CustomsUIError';
import IosShareIcon from '@mui/icons-material/IosShare';
import CheckIcon from '@mui/icons-material/Check';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';

const CustomsUIMAWB = ({ fileCodes, loginUser, order, setOrder, setLoader }) => {
    const dispatch = useDispatch();
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);

    //const [data, setData] = useState(order.mlVerify ? JSON.parse(order.mlVerify) : null);
    const [data, setData] = useState(null);

    const fileInputMAWBRef = useRef(null);

    useEffect(() => {
    }, [order]);

    const verifymawb = () => {
        if (order.mlVerifying) {
            alert("MAWB files processing already running!");
            return;
        }
        if (fileNum1(9) == 1 && fileNum(7) >= 1) {
            if (fileNum(7) < 1) {
                alert("One or more MAWB files are requied for MAWB verification.");
                return;
            } else {
                sendRequest('/api/customsUI/verifymawb?orderId=' + order.id + "&setId=1&user=" + loginUser.id, REQUEST_ACTIONS.POST, '', {
                    loginUser: loginUser,
                    successCallback: response => {
                        if (response)
                            setOrder(response);
                    },
                    failedCallback,
                });
            }
        } else {
            alert("Please make sure you have uploaded 1 MAWB and atleast 1 HAWB before you verify MAWB.");
        }
    }
    const getFileCodes = (codeId) => {
        const code = fileCodes.find(code => code.id === codeId);
        return code?.name?.replace(/ /g, "_")?.toUpperCase();
    }
    const fileNum = (type) => {
        var count = 0;
        for (var i = 0; i < order.orderStage[4].archives?.length; i++) {
            if (order.orderStage[4].archives[i].codeId == type) {
                count++;
            }
        }
        return count;
    }
    const fileNum1 = (type) => {
        var count = 0;
        for (var i = 0; i < order.orderStage[4].archives?.length; i++) {
            if (order.orderStage[4].archives[i].codeId == type) {
                count++;
            }
        }
        return count;
    }
    const mawbFileHandler = (event) => {
        if (event.preventDefault) event.preventDefault();
        if (event.stopPropagation) event.stopPropagation();

        const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        if (!files || files.length === 0) return;

        if (fileNum1(9) > 0) {
            if (confirm("MAWB file already uploaded, are you sure you want to remove it?")) {
                try {
                    removeFileWithoutPrompt();
                } catch (e) {
                    removeFileWithoutPrompt(null);
                    console.log(e);
                }
            } else {
                return;
            }
        }

        setLoader(true);
        var codeId = 9;
        var orderStageId = order.orderStage[4].id;
        const file = files[0];
        const time_now = new Date().toLocaleString("en-EN", { timeZone: 'Israel' }).split(",");
        const cur_date = time_now[0].split("/");
        const file_ext = file.name.split(".");
        const ext = file_ext[file_ext.length - 1];
        const show_name = "" + getFileCodes(codeId) + "_" + cur_date[0] + "_" + cur_date[1] + "_" + cur_date[2] + "_" + new Date(time_now).getTime() + "." + ext;
        const codeFileName = {
            codeId,
            fileName: show_name,
        };
        const formData = new FormData();
        formData.append('code', JSON.stringify([codeFileName]));

        formData.append('files', file, show_name);
        formData.append('orgName', file.name);
        formData.append('orderStageId', orderStageId);
        formData.append('orderId', order.id);
        formData.append('loginUserId', loginUser.id);
        formData.append('sId', null);

        sendRequest('/api/upload', REQUEST_ACTIONS.POST, formData, {
            successCallback: message => {
                setOrder(message);
                if (fileInputMAWBRef.current) {
                    fileInputMAWBRef.current.value = "";
                }
                setLoader(false);
            },
            failedCallback,
        });
    }

    const removeFile = (file) => {
        if (confirm("Are you sure you want to remove the file?")) {
            setLoader(true);
            sendRequest(`/api/files/${order.orderStage[4].archives?.find(f => f.name === file.name)?.id}/${loginUser.id}/${order.id}/${file.name}`, REQUEST_ACTIONS.DELETE, '', {
                successCallback: (message) => {
                    updateOrder();
                },
                failedCallback,
            });
        }
    }

    const removeFileWithoutPrompt = () => {
        setLoader(true);
        var f = order.orderStage[4].archives?.filter(f => f.codeId === 7);
        for (var i = 0; i < f.length; i++) {
            file = { codeId: 7, file: f[i].name };
            sendRequest(`/api/files/${order.orderStage[4].archives?.find(f => f.name === file.file)?.id}/${loginUser.id}/${order.id}/${file.file}`, REQUEST_ACTIONS.DELETE, '', {
                successCallback: (message) => {
                    updateOrder();
                },
                failedCallback,
            });
        }
    }

    const updateOrder = () => {
        sendRequest(`/api/order/${order.id}`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                setOrder(response);
                setLoader(false);
            },
            failedCallback,
        });
    }
    
    const onButtonClickMAWB = () => {
        fileInputMAWBRef.current.click();
    };

    return (
        <Grid item container style={{ borderTop: "1px grey solid", padding: "10px 20px" }}>
            <Grid item container style={{ margin: "10px", background: "white", borderRadius: "9px" }} alignItems="center">
                <Grid item container style={{ margin: "10px" }} alignItems="center" justifyContent="flex-end">
                    <Button
                        variant='contained'
                        style={{
                            border: "1px solid #0b5cab",
                            margin: "0 5px",
                            borderRadius: "5px",
                            padding: "5px 8px",
                            background: "linear-gradient(#1682cf, #0965ae)",
                            color: "#fff",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor: "pointer"
                        }}
                        onClick={() => {
                            //verifymawb();
                        }}>
                        MAWB Verify
                    </Button>
                </Grid>
                <Grid item container flexWrap="nowrap" style={{ marginTop: "10px" }}>
                    <Grid item container lg={4} style={{ border: "1px #cdd9e2 solid", borderRadius: "5px", padding: "5px", margin: "10px" }} flexDirection="row" flexWrap="nowrap">
                        <div style={{ width: "100%", display: "block", overflowY: "auto", overflowX: "hidden" }}>
                            <table style={{ margin: "5px", width: "calc(100% - 5px)" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ backgroundColor: "#fff", textAlign: "left" }}>
                                            <Grid item container justifyContent="center">
                                                <div
                                                    className={`drop-zone`}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    onDrop={mawbFileHandler}
                                                    onClick={onButtonClickMAWB}
                                                    style={{
                                                        border: `2px dashed #4A90E2}`,
                                                        padding: "10px",
                                                        textAlign: "center",
                                                        borderRadius: "8px",
                                                        background: "#f8fbfd",
                                                        cursor: "pointer",
                                                        width: "100%"
                                                    }}
                                                >
                                                    {/* Hidden file input */}
                                                    <input
                                                        ref={fileInputMAWBRef}
                                                        type="file"
                                                        multiple
                                                        onChange={mawbFileHandler}
                                                        style={{ display: "none" }}
                                                    />

                                                    <p style={{ width: "100%", padding: "0" }}>Upload <strong>MAWB</strong> here </p>
                                                    <IosShareIcon style={{ marginBottom: "10px" }} />

                                                </div>
                                            </Grid>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {<Grid item container alignContent="flex-start" style={{ marginTop: "10px" }}>
                                                {order.orderStage[4].archives?.filter(f => f.codeId == 9)?.map(file => (<Grid lg={11} item container style={{ overflow: "hidden" }} justifyContent="flex-start" flexWrap="nowrap">
                                                    <div onClick={() => { removeFile(file) }} style={{ marginRight: "10px", paddingLeft: "20px", color: "#c53b3b" }}>X</div>
                                                    <div><a href={file.uri} style={{ color: "#315a78", fontSize: "14px" }} target="_blank">{file.orgName ? file.orgName?.slice(0, 40) : file.name?.slice(0, 40)}</a></div>
                                                </Grid>))}
                                            </Grid>}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Grid>
                    <Grid item container lg={8} style={{ border: "1px #cdd9e2 solid", borderRadius: "5px", padding: "5px", margin: "10px" }} flexDirection="row" flexWrap="nowrap">
                        <div style={{ width: "100%", maxHeight: "530px", display: "block", overflowY: "auto" }}>
                            <table style={{ padding: "5px", textAlign: "center", border: "1px solid #dce5ec", borderRadius: "9px", width: "100%" }}>
                                <thead>
                                    <tr>
                                        <td style={{
                                            height: "30px", borderBottom: "1px solid #dce5ec", backgroundColor: "#fbfdff", textAlign: "left"
                                        }}>
                                            <Grid item container>
                                                <p style={{ padding: "5px", margin: 0, fontWeight: "bold", color: "#174f7c" }}>Validation Summary</p>
                                            </Grid>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.validations?.checks?.map(err => (<tr style={{ height: "35px", maxHeight: "35px" }}>
                                        <td style={{ height: "30px", background: "white", textAlign: "left", borderBottom: "1px solid #edf2f5" }}>
                                            <Grid title={err.message} item container flexWrap="nowrap" flexDirection="column" style={{ padding: "10px" }}>
                                                <b style={{ margin: 0, padding: 0, color: "#c53b3b" }} title={err.message}>{err.label}</b>
                                                <p title={err.message} style={{ marginTop: "5px", wordBreak: "break-all", color: "#708191", fontSize: "12px" }}>
                                                    {err.message.slice(0, 100)}
                                                </p>
                                            </Grid>
                                            {/*<p style={{ margin: "5px", wordBreak: "break-all" }} title={err[2]}>
                                        <span style={{ fontWeight: "bold" }}>{err[0]}</span>: <span>{err[1]}</span>
                                    </p>*/}
                                        </td>
                                    </tr>))}
                                </tbody>
                            </table>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            
        </Grid>
    );
}


export default CustomsUIMAWB;